// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2H4OM","notes":"Notes_notes__2E4wh"};